const apiBaseUrl =  'https://api.xpkart.com'
const imageBaseurl =  'https://api.xpkart.com/uploads/'
// const apiBaseUrl = 'http://localhost:5000'
// const imageBaseurl = 'http://localhost:5000/uploads/'

const localhostKey ={
  token:'at'
}

export const siteData = {
  name: "XP Kart",
}

const pageRoute = {
  login:"/login", 
  signUp:'/sign-up',
  profile:'/profile',
  payoutDetails:'/payout-details',
  vendorBusinessDetails:'/vendor-business-details',
  vendorEarning:'/earnings',
  categoryBanner:'/category-banner',
  bannerList:'/banner',
  logoManagement:'/logo-management',
  sliderManagement:'/slider-management',
  categoryManagement:'/category-management',
  productAdd:'/product-add',
  productList:'/product-list',
  brandManagement:'/brand-management',
  orderList:'/order-list',
  orderView:'/order-view/',
  returnList:'/return-list',
  allReview:'/review-list',
  userList:'/user-list',
  productView:'/product-view/',
  productEdit:'/product-edit/',
  dashboard:'/dashboard',
  newsLatter:'/news-latter',
  contactUsList:'/contact-us-list',
  order:'/order',
  coupons:'/coupons'
}

const getImageFullUrl =  (url)=>{
    return imageBaseurl + url
}

export{
  apiBaseUrl,imageBaseurl, localhostKey, pageRoute, getImageFullUrl
}